/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';
import classnames from 'classnames';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const Footer = ({children, className, ...rest}) => {
    const classes = classnames("card__footer");
    return <Box className={classes}>{children}</Box>;
}

export default Footer;
    